module.exports = __webpack_public_path__ + "img/apple-ear-pods.dea5dc4f.jpg";